import api from "./api";

class BusinessUnitsManager {

    businessUnits(config?: any) {
        return api.get(`/businessunits`, config)
    }

    businessUnit(id: number | string, config?: any) {
        return api.get(`/businessunits/${id}`, config)
    }

    lavoriNewBusiness(cliente_id: number | string) {
        return api.get(`/clienti/${cliente_id}/lavori_new_business`)
    }

    nonInteressato(cliente_id: number | string) {
        return api.get(`/clienti/${cliente_id}/non_interessato`)
    }

    salvaBusinessUnit(id: number | string, data = {}) {
        return api.put(`/businessunits/${id}`, data)
    }

    boardUsers(id: number | string, data = {}) {
        return api.get(`/businessunits/${id}/boards`, data)
    }

    fasceRicavo(id: number | string, data = {}) {
        return api.get(`/businessunits/${id}/fasce_ricavo`, data)
    }

    saveFasceRicavo(id: number | string, fasce: any[]) {
        return api.put(`/businessunits/${id}/fasce_ricavo`, { fasce })
    }

    bilanciPrevisionali(id: number | string, config: any) {
        return api.get(`/businessunits/${id}/bilanci_previsionali`, config)
    }

    importaBilanciPrevisionali(id: number | string, data: any) {
        return api.post(`/businessunits/${id}/bilanci_previsionali/importa`, data)
    }

    createBilancioPrevisionale(id: number | string, data: any) {
        return api.post(`/businessunits/${id}/bilanci_previsionali/`, data)
    }

    updateBilancioPrevisionale(id: number | string, bid: number | string, data: any) {
        return api.put(`/businessunits/${id}/bilanci_previsionali/${bid}/`, data)
    }

    getBilancioPrevisionale(id: number | string, bid: number | string) {
        return api.get(`/businessunits/${id}/bilanci_previsionali/${bid}/`)
    }

    retrieveAll(ids: number[]) {
        return api.get(`/businessunits/ids`, {params: {ids}}) 
    }

    retrieve = this.businessUnit
    list = this.businessUnits
    paginatedList = this.businessUnits
}

const businessUnitsManager = new BusinessUnitsManager()

export default businessUnitsManager
